import { IconButton, Icon, Box, Typography } from '@mui/material';
import { Dispatch, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { calendarService, ICalendar } from '../../../services';

interface IProps {
  monthDay: ICalendar | undefined;
  setMonthDay: Dispatch<React.SetStateAction<ICalendar | undefined>>;
}

export const Calendar: React.FC<IProps> = ({ monthDay, setMonthDay }) => {

  const carousel = useRef<HTMLElement>(null);

  const { data: days } = useQuery(['days'], () =>
    calendarService.getDays(), {
    onSuccess: (data) => {
      setMonthDay(data[0]);
    }
  }
  );

  const handleLeftClick = () => {
    if (carousel.current) {
      carousel.current.scrollLeft -= 300;
    }
  };

  const handleRightClick = () => {
    if (carousel.current) {
      carousel.current.scrollLeft += 300;
    }
  };

  return (
    <Box display='flex' alignItems='center' gap={2}>
      <IconButton onClick={handleLeftClick} data-testid='btn-calendar-prev'>
        <Icon>arrow_back</Icon>
      </IconButton>

      <Box
        display='flex'
        alignItems='center'
        overflow='hidden'
        sx={{ scrollBehavior: 'smooth' }}
        gap={1}
        ref={carousel}
      >
        {days && days.map((day) =>
          <Box
            key={day.id}
            display='flex'
            flexDirection='column'
            justifyContent='center'
            alignItems='center'
            component='span'
            onClick={() => setMonthDay(day)}
            data-testid={`calendar-day-${day.id}`}
            sx={{
              backgroundColor: day === monthDay ? '#c2185b' : 'none',
              cursor: 'pointer'
            }}
            padding={1}
            borderRadius={1}
            draggable
          >
            <Typography color={day === monthDay ? 'secondary' : 'primary'}>{day.weekDay}</Typography>

            <Box display='flex' alignItems='center'>
              <Typography color={day === monthDay ? 'secondary' : 'primary'} fontSize={16} fontWeight='bold'>{day.monthDayString}</Typography>
              <Typography color={day === monthDay ? 'secondary' : 'primary'} fontSize={12}>/{day.monthString}</Typography>
            </Box>
          </Box>
        )}
      </Box>

      <IconButton onClick={handleRightClick} data-testid='btn-calendar-next'>
        <Icon>arrow_forward</Icon>
      </IconButton>
    </Box>
  );
};